import { render, staticRenderFns } from "./RawMaterialsPage.vue?vue&type=template&id=ab27e59a"
import script from "./RawMaterialsPage.vue?vue&type=script&lang=js"
export * from "./RawMaterialsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports